import { PartList } from 'services/availabilityBySource/types';
import { Components } from 'services/fbtItems/types';
import {
  MILLISECONDS_IN_A_SECOND,
  SECONDS_PER_DAY,
  SOFTWARE_PART_TYPE,
  SOFTWARE_PART_TYPE_TRAIN
} from '../constants/constants';

// Extended interface for bundle components that includes sosCode
interface ComponentsWithSOS extends Components {
  sosCode?: string;
}

export const getExpiryDateFromNow = (daysForExpiry: number) => {
  const date = new Date();
  const expiryTime =
    date.getTime() + daysForExpiry * SECONDS_PER_DAY * MILLISECONDS_IN_A_SECOND;
  date.setTime(expiryTime);
  return date.toUTCString();
};

export const partTypeSoftware = (partType) => {
  if(!partType) {
    return false;
  }

  return (
    partType === SOFTWARE_PART_TYPE || partType === SOFTWARE_PART_TYPE_TRAIN
  );
};
export const getPartsListForBundleBean = (
  products: ComponentsWithSOS[]
): PartList[] =>
  products?.map((item) => {
    return {
      partNumber: item?.partNumber,
      quantity: item?.quantity ?? 1,
      sosCode: item?.sosCode ?? null
    };
  });
